import styled from 'styled-components';
export var StyledContainer = styled.div.withConfig({
  displayName: "StyledContainer",
  componentId: "sc-n1dhlp-0"
})(["display:flex;flex-flow:row nowrap;align-items:center;gap:8px;"]);
export var StyledInputWrapper = styled.div.withConfig({
  displayName: "StyledInputWrapper",
  componentId: "sc-n1dhlp-1"
})(["display:flex;align-items:center;background:#fafafc;border:1px solid #e8e9f2;border-radius:56px;width:100%;height:56px;padding:8px 8px 8px 24px;"]);
export var StyledLabel = styled.span.withConfig({
  displayName: "StyledLabel",
  componentId: "sc-n1dhlp-2"
})(["font-size:16px;font-weight:400;line-height:140%;color:#5a5d6d;white-space:nowrap;"]);
export var StyledIncreaseButtons = styled.div.withConfig({
  displayName: "StyledIncreaseButtons",
  componentId: "sc-n1dhlp-3"
})(["display:flex;flex-flow:row nowrap;align-items:center;height:100%;padding:0 8px;border-radius:28px;border:1px solid #e2e5f1;background:#fff;"]);
export var StyledIncreaseButton = styled.div.withConfig({
  displayName: "StyledIncreaseButton",
  componentId: "sc-n1dhlp-4"
})(["width:28px;font-size:12px;font-weight:500;line-height:16px;color:#5f4dbc;cursor:pointer;"]);